<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/sys/channel/list' }"
        >集中申报期窗口设置</el-breadcrumb-item
      >
    </el-breadcrumb>
    <el-form
      class="flex-item role-form"
      ref="validateForm"
      :model="form"
      size="small"
      :rules="rules"
      :validate-on-rule-change="false"
      label-width="180px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="项目名称:" prop="project">
            <el-input v-model="project" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="申报时间窗口:" prop="channelName1">
            <el-input v-model="form.date"></el-input>
            <span style="color: red">说明：集中申报时间范围，01-10表示每个月1日-10日为申报期！</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="当前状态:" prop="channelName1">
            <span>{{form.state}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="flex-item" style="text-align: center">
      <el-button size="small" type="primary" @click="save(1)">放开</el-button>
      <el-button size="small" type="primary" @click="save(2)">关闭</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      project:'2026年北京市加力支持家电以旧换新补贴资金监管服务项目',
      roleList: null,
      departmentList: null,
      id: null,
      load: false,
      tableLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableList: [],
      form: {date:'01-10',state:'开启'},
      isOneself: false,
      clickFlag: true,
    };
  },
  mounted() {
    if (this.$route.params.id) {
        this.form.id=this.$route.params.id;
        this.id=this.$route.params.id;
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    save(flag) {
      this.$refs["validateForm"].validate((valid) => {
        if (valid) {
          if(flag=='1'){
            this.form.state="放开";
          }else{
            this.form.state="关闭";
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
            loading.close();
          }, 1000);
        } else {
          this.$message.error("请填写必填项");
          return false;
        }
      });
    },
      // send() {
      //     const fileExtension = str.substring(str.lastIndexOf(".") + 1);
      //     return fileExtension;
      // },
    // 提取文件后缀名
    getSuffix(str) {
      const fileExtension = str.substring(str.lastIndexOf(".") + 1);
      return fileExtension;
    },
  },
};
</script>

<style scoped>
.el-card {
  height: 100%;
}

.btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
}

.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.flex-item:nth-child(1),
.flex-item:nth-child(3) {
  flex-grow: 0;
  flex-shrink: 0;
}

.flex-item:nth-child(2) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.role-form {
  margin: 15px 0;
}
</style>